import { StaticJsonRpcProvider } from '@ethersproject/providers';

export const EthProvider = new StaticJsonRpcProvider('https://mainnet-nethermind.blockscout.com/');

export const BscProvider = new StaticJsonRpcProvider('https://bsc-dataseed1.defibit.io/');

export const XDaiProvider = new StaticJsonRpcProvider('https://rpc.xdaichain.com/');

export const MaticProvider = new StaticJsonRpcProvider('https://polygon-rpc.com/');
